import { z } from "zod";

import { UserInterfaceDtoSchema } from "../../../dtos/user-interfaces";

export const GetUserInterfacesResponseBodySchema = z.object({
  userInterfaces: UserInterfaceDtoSchema.array(),
});

export type GetUserInterfacesResponseBodyType = z.infer<
  typeof GetUserInterfacesResponseBodySchema
>;

export const GetUserInterfacesPathParamsSchema = z.object({
  variationId: z.string().uuid(),
});
export type GetUserInterfacesPathParamsType = z.infer<
  typeof GetUserInterfacesPathParamsSchema
>;
